import React from "react"
import SEO from "../components/seo"

// Wayfx Components
import ContactSuccess from "../components/ContactSuccess"

const SuccessPage = () => {
    return (
        <>
            <SEO title="Contact Us Success" />
            <ContactSuccess line1="Thanks! We'll be in touch soon." />
        </>
    )
}

export default SuccessPage